import { IconButton, Popover, Typography, makeStyles, Grid, Tooltip, Box } from "@material-ui/core";
import { useEffect, useState } from "react";
import WebFont from "webfontloader";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { connect, useDispatch, useSelector } from "react-redux";
import { getTemplateGroup } from "../function/templates";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { checkQuestion, cloneQuestion, deleteQuestion, updateQuestionSetting } from "../actions";
import Swal from "sweetalert2";
import FormHeader from "./FormHeader";
import FormPaging from "./FormPaging";
import WelcomeScreen from "./WelcomeScreen";
import DragHandleIcon from '@mui/icons-material/DragHandle';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const useStyles = makeStyles((props) => ({
  root: {
    backgroundImage:
      "linear-gradient(rgba(var(--color-brightness),var(--color-brightness),var(--color-brightness),var(--background-image-brightness)), rgba(var(--color-brightness),var(--color-brightness),var(--color-brightness),var(--background-image-brightness))), var(--background-image)",
    fontSize: "var(--font-size)",
    backgroundPosition: "center top",
    backgroundSize: "cover",
    backgroundColor: "var(--background-color)",
    fontFamily: "var(--font-family)",
    color: "var(--question-color)",
  },
  list: {
    width: 300,
  },
  questionActions: {
    width: "50px",
    marginRight: "15px",
  },
  iconLabel: {
    padding: 0,
  }
}));
const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#3f51b526" : "",
});
const getListStyleGroup = (isDraggingOver) => ({
  background: isDraggingOver ? "#3f51b526" : "#b5b5b51a",
  marginBottom: '10px'
});
const getItemStyle = (isDragging, draggableStyle) => ({
  // change background colour if dragging
  background: isDragging ? "lightgreen" : "",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const FormContent = (props) => {
  const {language, questionsList, current_page, pages, fontFamily, questionChecked} = useSelector((state) => ({
    questionsList: state.questionsList,
    questionChecked: state.question_checked,
    question: state.questionsList[state.question_checked],
    current_page: state.current_page,
    pages: state.pages,
    language: state.form_settings.default_language,
    fontFamily : state.theme_config.font_family
  }));

  const dispatch = useDispatch();
  const classes = useStyles(props);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorId, setAnchorId] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setAnchorId(event.currentTarget.getAttribute("data-questionid"));
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorId("");
  };

  useEffect(() => {
    WebFont.load({
      google: {
        families: [fontFamily],
      },
    });
  }, [fontFamily]);
  const [initialPos, setInitialPos] = useState(null)
  const [initialSize, setInitialSize] = useState(null)
  const [initialPos2, setInitialPos2] = useState(null)
  const [initialSize2, setInitialSize2] = useState(null)
  const [temp, setTemp] = useState(6)
  const [onresize, setOnresize] = useState(false)

  const initial = (e,question) => {
    let resizable = document.getElementById('Resizable'+question);
    setInitialPos(e.clientX);
    setInitialSize(resizable.offsetWidth);
    if(!(initialPos2 && initialSize2)){
      setInitialPos2(e.clientX);
      setInitialSize2(resizable.offsetWidth);
    }
  }
  const resize = (e,question) => {
    let resizable = document.getElementById('Resizable'+question);
    setOnresize(true)
    if(e.clientX > 0 && e.clientX < initialPos){
      
      let column = questionsList[question].gridformat.colspan || 6
      let sizeStep = parseInt(initialSize/column)

      let test = parseInt((parseInt(e.clientX - initialPos)/sizeStep))
      if(test !== temp && test > -6 && test <6){
        setTemp(column + test)
        resizable.style.width = `${parseInt(initialSize) + parseInt(test*sizeStep)}px`;
      }
    }else if(e.clientX > initialPos){
      let sizeStep = parseInt(initialSize2/6)

      let test = parseInt((parseInt(e.clientX - initialPos2)/sizeStep))
      if(test !== temp && test > -6 && test <6){
        setTemp(6 + test)
        resizable.style.width = `${parseInt(initialSize2) + parseInt(test*sizeStep)}px`;
      }
    }

    
  };
  const stop = (e,question) => { 
    dispatch(updateQuestionSetting(question, `grid`, temp));
    setOnresize(false)
  };
  if(current_page && current_page === 'welcome'){
    return (
      <div className={classes.root }>
        <WelcomeScreen/>
      </div>
    )
  }
 return (
    <>
      <Droppable
          droppableId={"form-content-droppable"}
          isDropDisabled={props.disableDropableGroupParent}
        >
          
          {(provided, snapshot) => {
            return (
              <div
                className={ "MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 " + classes.root }
                style={{ minHeight: "300px", position:"relative", ...getListStyle(snapshot.isDraggingOver)}}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                <FormHeader />
                {
                pages[current_page].map((questionId, index) => {
                  
                  if(questionsList[questionId].type === 'row'){
                    <RowComponent key={questionId} {...{ questionId, index}}/>
                  }
                  let listNameCheck = Object.values(questionsList)?.map((question) => question.name);
                  listNameCheck.splice(listNameCheck.indexOf(questionsList[questionId].name),1);
                  let classError = " div-wrapper";
                  if (listNameCheck.indexOf(questionsList[questionId].name) > -1 || !questionsList[questionId].name || (questionsList[questionId].name && !questionsList[questionId].name?.match(/^[a-zA-Z0-9_-]+$/))) {
                    classError = " duplicate-name";
                  }
                  if (props.previewForm) {
                    classError = "";
                  }
                  if(!props.previewForm && questionId === props.question_checked){
                    classError+= " question_checked"
                  }
                  let AppearanceGroup =questionsList[questionId].collector.AppearanceGroup;
                  let templateHtml = getTemplateGroup(AppearanceGroup,questionsList[questionId],language,questionId);  
                  let col = ''
                  if((questionChecked != questionId) || (!onresize && questionChecked === questionId)){
                    col = questionsList[questionId]?.gridformat.colspan*2
                  }
                  return (
                    <div
                      className={"Resizable MuiGrid-root MuiGrid-item m-0 MuiGrid-grid-xs-"+col }
                      key={questionId + index + "-root-wrap"}
                      id = {'Resizable'+questionId}
                      style={{textAlign: questionsList[questionId].gridformat.align, width:'100%', position:'relative'}}
                    >
                      
                            <Draggable
                              key={questionId + index}
                              draggableId={questionId}
                              index={index}
                            >
                              {(provided, snapshot) => {
                                const question = questionsList[questionId];
                                let templateClass = questionsList[questionId].collector.AppearanceGroup;
                                return (
                                  <>

                                    
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if(questionChecked !== questionId){
                                          dispatch(checkQuestion(questionId));
                                        }
                                      }}
                                      style={getItemStyle( snapshot.isDragging, provided.draggableProps.style )}
                                    >
                                      <Box sx={{position:'absolute', top:'40%'}} {...provided.dragHandleProps} data-questionid={questionId} size="small">
                                      {
                                      !props.previewForm &&
                                        <DragIndicatorIcon />
                                      }
                                      </Box >
                                      <Tooltip open={snapshot.isDragging} title="Drop a block out of the workspace to cancel the task" >
                                        <Grid container>
                                          {!props.previewForm && (
                                            <Grid item xs={1}>
                                              {
                                                questionId == questionChecked &&
                                                <IconButton style={{position: 'absolute', left: '35px', top: '5px'}} data-questionid={questionId} size="small" onClick={handleClick} >
                                                  <MoreVertIcon />
                                                </IconButton>
                                              }
                                            </Grid>
                                          )}

                                          <Grid item xs={props.previewForm ? 12 : 11}>
                                            {
                                            questionId.indexOf("group_template") >-1 ? 
                                            (
                                              <GroupTemplateComponent
                                                key={"group"+questionId}
                                                {...{
                                                  ...props,
                                                  templateHtml,
                                                  questionsList,
                                                  questionId,
                                                  questionChecked,
                                                  language,
                                                  provided,
                                                  templateClass,
                                                  classError,
                                                }}
                                              />
                                            ) : 
                                            questionId.indexOf("group") > -1 || questionId.indexOf("repeat") > -1 ? 
                                            (
                                              // TODO: fix bug drag and drop
                                              <Droppable
                                                key={questionId + index + "droppable"}
                                                droppableId={`${question.type}-droppable##${questionId}`}
                                                isDropDisabled={ props.disableDropableGroup }
                                              >
                                                {(provided, snapshot) => {
                                                  return (
                                                    <div
                                                      className={ "form-content-droppable-div MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 " + classError }
                                                      style={{
                                                        minHeight: "200px",
                                                        paddingTop: "10px",
                                                        paddingBottom: "70px",
                                                        ...getListStyleGroup(
                                                          snapshot.isDraggingOver
                                                        ),
                                                      }}
                                                      // {...provided.draggableProps}
                                                      // {...provided.dragHandleProps}
                                                      ref={provided.innerRef}
                                                    >
                                                      {/* <div {...provided.dragHandleProps} style={{width:'20px', height:'20px',background:'red'}}/> */}
                                                      {
                                                      questionsList[questionId]?.children?.map(
                                                          (id, index) => {
                                                            let AppearanceGroup = questionsList[id].collector.AppearanceGroup;
                                                            const templateHtml = getTemplateGroup( AppearanceGroup, questionsList[id],language,id);
                                                            let listNameCheck = Object.values(questionsList)?.map((question) =>question.name);
                                                            listNameCheck.splice(listNameCheck.indexOf(questionsList[id].name),1);
                                                            let classError =" div-wrapper";
                                                            if (listNameCheck.indexOf(questionsList[id].name) > -1 || !questionsList[id].name || (questionsList[id].name && !questionsList[id].name?.match(/^[a-zA-Z0-9_-]+$/))) {
                                                              classError = " duplicate-name";
                                                            }
                                                            if (props.previewForm) {
                                                              classError = "";
                                                            }
                                                            if(!props.previewForm && id === props.question_checked){
                                                              classError+= " question_checked"
                                                            }
                                                            let col = ''
                                                            if((questionChecked != id) || (!onresize && questionChecked === id)){
                                                              col = questionsList[id]?.gridformat.colspan*2
                                                            }
                                                            return (
                                                              <div
                                                                key={`wrapper-${id}${index}`}
                                                                // className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                                                                className={"Resizable MuiGrid-root MuiGrid-item m-0 MuiGrid-grid-xs-"+col }
                                                                id = {'Resizable'+id}
                                                                style={{textAlign: questionsList[id].gridformat.align, width:'100%', position: 'relative'}}
                                                              >
                                                                <Draggable
                                                                  key={`children${id}${index}`}
                                                                  draggableId={ id }
                                                                  index={index}
                                                                >
                                                                  {(provided,snapshot) => {
                                                                    if (snapshot.isDragging) {
                                                                      provided.draggableProps.style =
                                                                        {
                                                                          ...provided.draggableProps.style,
                                                                          left: provided.draggableProps.style.offsetLeft,
                                                                          top: provided.draggableProps.style.offsetTop,
                                                                        };
                                                                    }
                                                                    return (
                                                                      <>
                                                                      
                                                                        <div
                                                                          ref={
                                                                            provided.innerRef
                                                                          }
                                                                          {...provided.draggableProps}
                                                                          // {...provided.dragHandleProps}
                                                                          onClick={( e ) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            if(questionChecked !== id){
                                                                              dispatch(checkQuestion(id));
                                                                            }
                                                                          }}
                                                                          style={getItemStyle(snapshot.isDragging,provided.draggableProps.style)}
                                                                        >
                                                                          <Box sx={{position:'absolute', top:'40%'}} {...provided.dragHandleProps} data-questionid={questionId} size="small">
                                                                          {!props.previewForm &&
                                                                          
                                                                            <DragIndicatorIcon />
                                                                          }
                                                                          </Box >
                                                                          <Tooltip open={snapshot.isDragging} title="Drop a block out of the workspace to cancel the task">
                                                                            <Grid container >
                                                                              {!props.previewForm && (
                                                                                <Grid item xs={1} >
                                                                                  {
                                                                                    id == questionChecked &&
                                                                                    <IconButton
                                                                                      data-questionid={ id }
                                                                                      size="small"
                                                                                      className="question-actions"
                                                                                      onClick={ handleClick }
                                                                                      style={{position: 'absolute', left: '35px', top: '5px'}}
                                                                                    >
                                                                                      <MoreVertIcon />
                                                                                    </IconButton>
                                                                                  }
                                                                                </Grid>
                                                                              )}
                                                                              <Grid item xs={11}>
                                                                                <div className={ classError }>{templateHtml}</div>
                                                                              </Grid>
                                                                            </Grid>
                                                                          </Tooltip>
                                                                          <Popover
                                                                            key={`checkquestionpopover${id}`}
                                                                            id={anchorId}
                                                                            open={ anchorId === id }
                                                                            anchorEl={ anchorEl }
                                                                            onClose={ handleClose }
                                                                            anchorOrigin={{ vertical: "bottom", horizontal: "center", }}
                                                                            transformOrigin={{ vertical: "top", horizontal: "center", }}
                                                                          >
                                                                            <Typography>
                                                                              <IconButton
                                                                                color="secondary"
                                                                                aria-label="delete"
                                                                                onClick={() => {
                                                                                  handleClose()
                                                                                  Swal.fire({
                                                                                    icon:'question',
                                                                                    title: 'Do you want to delete '+ questionsList[id].name+' ?',
                                                                                    showCancelButton: true,
                                                                                    confirmButtonText: 'Yes! Delete it.',
                                                                                    cacelButtonText: `No`,
                                                                                    confirmButtonColor:"var(--red-color)"
                                                                                  }).then((result) => {
                                                                                    /* Read more about isConfirmed, isDenied below */
                                                                                    if (result.isConfirmed) {
                                                                                      dispatch(deleteQuestion( current_page, id ));
                                                                                    }
                                                                                  })
                                                                                }}
                                                                              >
                                                                                <DeleteIcon />
                                                                              </IconButton>
                                                                              <IconButton aria-label="clone" onClick={() => { dispatch(cloneQuestion(id,1))}}>
                                                                                <FileCopyIcon />
                                                                              </IconButton>
                                                                            </Typography>
                                                                          </Popover>
                                                                        </div>
                                                                      </>
                                                                    );
                                                                  }}
                                                                </Draggable>
                                                                {
                                                                  !props.previewForm && id == questionChecked && (id.indexOf('_template') == -1 && id.indexOf('group_') == -1) &&
                                                                  <div 
                                                                    id ={'resize-'+id} 
                                                                    draggable   = 'true'
                                                                    className = 'Draggable'
                                                                    onDragStart = {(e)=>{initial(e,id)}} 
                                                                    onDrag      = {(e)=>{resize(e,id)}}
                                                                    onDragEnd = {(e)=>{stop(e,id)}} 
                                                                  >
                                                                    <DragHandleIcon sx={{transform: "rotate(90deg)"}}/>
                                                                  </div>
                                                                }
                                                              </div>
                                                            );
                                                          }
                                                        )}
                                                      {provided.placeholder}
                                                    </div>
                                                  );
                                                }}
                                              </Droppable>
                                            ) : (
                                              <div className={classError}>
                                                {templateHtml}
                                              </div>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Tooltip>
                                    </div>
                                    <Popover
                                      key={`checkquestionpopover${questionId}`}
                                      id={anchorId}
                                      open={anchorId === questionId}
                                      anchorEl={anchorEl}
                                      onClose={handleClose}
                                      anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                                      transformOrigin={{vertical: "top",horizontal: "center"}}
                                    >
                                      <Typography>
                                        <IconButton
                                          color="secondary"
                                          aria-label="delete"
                                          onClick={() => {
                                            handleClose()
                                            Swal.fire({
                                              icon:'question',
                                              title: 'Do you want to delete '+ questionsList[questionId].name+' ?',
                                              showCancelButton: true,
                                              confirmButtonText: 'Yes! Delete it.',
                                              cancelButtonText: `No`,
                                              confirmButtonColor:"var(--red-color)"
                                            }).then((result) => {
                                              if (result.isConfirmed) {dispatch(deleteQuestion(current_page, questionId))}
                                            })
                                          }}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                        <IconButton
                                          aria-label="clone"
                                          onClick={() => {dispatch(cloneQuestion(questionId, 1))}}
                                        >
                                          <FileCopyIcon />
                                        </IconButton>
                                      </Typography>
                                    </Popover>
                                  </>
                                );
                              }}
                            </Draggable>
                        {
                          !props.previewForm && questionId == questionChecked && questionId.indexOf('_template') == -1 && questionId.indexOf('group_') == -1 &&
                          <div 
                            id ={'resize-'+questionId} 
                            draggable   = 'true'
                            className = 'Draggable'
                            onDragStart = {(e)=>{initial(e,questionId)}} 
                            onDrag      = {(e)=>{resize(e,questionId)}}
                            onDragEnd = {(e)=>{stop(e,questionId)}} 
                          >
                            <DragHandleIcon sx={{transform: "rotate(90deg)"}}/>
                          </div>
                        }
                      </div>
                  );
                })
                }
                {provided.placeholder}
                {
                  props.theme_config.show_shortcuts == "1" &&
                  <KeyHelper/>
                }
                
                <div style={{marginTop:props.previewForm ? "50px" : "70px", width:"100%"}}>
                  <FormPaging/>
                </div>
              </div>
            );
          }}
      </Droppable>
    </>
  );
};
const KeyHelper = () =>{
	return(
        <div className={' col-12 mt-2 key-helper-wrap'}>
            <div className='d-flex align-items-center'>
                <label 
                    className="btn btn-icon tf-btn tf-btn-power" 
                    style={{width:"4rem !important"}}>
                            <b>
                            OK
                            </b>
                </label>
                <p className="ml-2 key-helper-text">press <strong>Enter ↵</strong></p>
            </div>
            {/* <p className="shift-enter mt-2">{rta_t("press ")}<strong>Ctrl</strong> + <strong>Enter ↵</strong> {rta_t(" to go back.")}</p> */}
        </div>
        
    )
}
const mapStateToProps = (state, props) => {
  return {
    ...state,
  };
};

const GroupTemplateComponent = ({ ...props }) => {
  return (
    <div
      className={props.templateClass +" form-content-droppable-div MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3" +props.classError}
      style={{
        minHeight: "200px",
        paddingTop: "10px",
        paddingBottom: "70px",
      }}
    >
      {
      props.questionsList[props.questionId] && props.questionsList[props.questionId].children.map(
          (
            questionId, index) => {
            let question = props.questionsList[questionId];
            let listNameCheck = Object.values(props.questionsList)?.map(
              (question) => question.name
            );
            listNameCheck.splice(listNameCheck.indexOf(question.name), 1);
            let classError = " div-wrapper";
            if (listNameCheck.indexOf(question.name) > -1 || !question.name || (question.name && !question.name?.match(/^[a-zA-Z0-9_-]+$/))) {
              classError = " duplicate-name";
            }
            if (props.previewForm) {
              classError = "";
            }
            if(!props.previewForm && questionId === props.question_checked){
              classError+= " question_checked"
            }
            const templateHtmlNew = getTemplateGroup( props.questionsList[questionId].collector.AppearanceGroup,props.questionsList[questionId], props.language, questionId );
            let colspan = props.questionsList[questionId].gridformat.colspan * 2;
            return (
              <div 
              key={"question-"+questionId}
                className={ "MuiGrid-root MuiGrid-item MuiGrid-grid-xs-" + colspan}
                style={{textAlign: props.questionsList[questionId].gridformat.align}}
              >
                <div
                  ref={props.provided.innerRef}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if(props.questionChecked !== questionId){
                      props.dispatch(checkQuestion(questionId));
                    }
                    // props.dispatch(toggleDrawer("questionConfig", true));
                  }}
                  className={classError}
                >
                  {templateHtmlNew}
                </div>
              </div>
            );
          }
        )}
      {props.provided.placeholder}
    </div>
  );
};

const RowComponent = ({...props})=>{
  return (
    <div
      className={"MuiGrid-root MuiGrid-item m-0 MuiGrid-grid-xs-12"}
      key={props.questionId + props.index + "-root-wrap"}
      style={{border: "1px dashed #4051b6"}}
    >
      <Draggable
        key={props.questionId + props.index}
        draggableId={props.questionId}
        index={props.index}
      >
        {(provided, snapshot) => {
          return (
            <>
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                {/* <div {...provided.dragHandleProps} style={{width:'20px', height:'20px',background:'red'}}/> */}
              <Droppable droppableId="droppable-1" type="PERSON">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={{ backgroundColor: snapshot.isDraggingOver ? 'blue' : 'grey' }}
                    {...provided.droppableProps}
                  >
                  </div>
                )}
              </Droppable>
              </div>
            </>
          )
        }}
    </Draggable>
    </div>
  )
}

export default connect(mapStateToProps)(FormContent);
